import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { InvitationThroughEnum } from 'app/main/pages/general-editor-tabs/recipients-tab/recipient-tab.dto';

@Pipe({
    name: 'invitationType',
})

/**
 * return the inviation type svg
 */
export class InvitationTypePipe implements PipeTransform {
    transform(type: string, isReturnLabeL: boolean = false): { svg: string, type: string } {
        const types = {
            [InvitationThroughEnum.EMAIL]: translate("Invitation email tooltip text (Template/Document RecipientTab - section) - Email"),
            [InvitationThroughEnum.EMAIL_AND_SMS]: translate("Invitation email and sms tooltip text (Template/Document RecipientTab - section) - Email and SMS"),
            [InvitationThroughEnum.POS]: translate("Invitation POS tooltip text (Template/Document RecipientTab - section) - POS"),
            [InvitationThroughEnum.IN_MEETING]: translate("Invitation in meeting tooltip text (Template/Document RecipientTab - section) - In meeting"),
            [InvitationThroughEnum.GET_LINK]: translate("Invitation get link tooltip text (Template/Document RecipientTab - section) - Get Link"),
            [InvitationThroughEnum.SMS]: translate("Invitation sms tooltip text (Template/Document RecipientTab - section) - SMS"),
            [InvitationThroughEnum.SAME_DEVICE]: translate("Invitation same device tooltip text (Template/Document RecipientTab - section) - Same device")
        }
        if (isReturnLabeL) { return types[type] }
        return { svg: `assets/images/invitation-icons/${type}.svg`, type: `${types[type]}` };
    }
}
